module.exports = __webpack_public_path__ + "img/firstR.2424cce5.svg";